import quoteModal from "../../Configs/JSON/quoteModal.json";
import { callMiddlewareAPI } from "../Common/CommonFunctions";
import AppStore from "../../Configs/Store/index";
import { ApiName } from "@ipru-common/services/ApiEndpoints.js";
// Commented as Quote API on PreProd is Down Causing Failure of Journey.
const CALCULATE_RETURN_URL = window.location.href.includes("testing")
  ? process.env.REACT_APP_CALCULATE_RETURN_PREPROD_URL
  : process.env.REACT_APP_CALCULATE_RETURN_PROD_URL;
// const CALCULATE_RETURN_URL = process.env.REACT_APP_CALCULATE_RETURN_PROD_URL
const MALE_GENDER_ARRAY = ["Father", "Husband", "Son", "Brother"];
const FEMALE_GENDER_ARRAY = ["Mother", "Wife", "Daughter", "Sister"];
const marriedArray = ["Me_&_Joint_life", "Me_Joint_life_&_nominee"];

const PayoutOptions = {
  0: "DEFERRED SINGLE LIFE WITH RETURN OF PURCHASE PRICE",
  1: "DEFERRED SINGLE LIFE WITH RETURN OF PURCHASE PRICE ON CI OR PD OR DEATH",
  2: "DEFERRED JOINT LIFE WITH RETURN OF PURCHASE PRICE",
  3: "LIFE ANNUITY WITHOUT RETURN OF PURCHASE PRICE",
  4: "JOINT LIFE, LAST SURVIVOR WITHOUT RETURN OF PURCHASE PRICE",
  5: "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE",
  6: "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE AT AGE 80",
  7: "LIFE ANNUITY WITH RETURN OF 50 PERCENT PURCHASE PRICE AT AGE 80",
  8: "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE FROM THE AGE OF 76",
  9: "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE ON CI OR PD OR DEATH",
  10: "JOINT LIFE, LAST SURVIVOR WITH RETURN OF PURCHASE PRICE",
  11: "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE ON CI OR PD OR DEATH",
  12: "FamilyInc ROP Single Life",
  13: "FamilyInc ROP Joint Life",
};

const QuoteAPI = async (
  FormStore,
  CalcForm,
  QuoteForm,
  QuoteFormGetFieldS = true,
) => {
  // ExtraForm = SWP/AWT
  var CalcFormValues = await CalcForm.getFieldsValue();
  var QuoteFormValues;
  if (QuoteFormGetFieldS) {
    QuoteFormValues = await QuoteForm.getFieldsValue();
  } else {
    // QuoteFormValues = await QuoteForm.getFieldsValue()
    QuoteFormValues = QuoteForm;
  }

  var Gender =
    FormStore.calc_gender === "Other" ? "Male" : FormStore.calc_gender;
  var PensionFrequency = QuoteFormValues["annuityFreq"];
  var ModalPremium = QuoteFormValues["investmentAmount"] + "";
  ModalPremium = ModalPremium.includes(",")
    ? ModalPremium.replace(/,/g, "")
    : ModalPremium;
  ModalPremium = ModalPremium === "" ? "0" : Number(ModalPremium);
  var AnnuityAmount = QuoteFormValues["annuityAmount"] + "";
  AnnuityAmount = AnnuityAmount.includes(",")
    ? AnnuityAmount.replace(/,/g, "")
    : AnnuityAmount;
  AnnuityAmount = AnnuityAmount === "" ? "0" : Number(AnnuityAmount);
  if (AnnuityAmount !== "0") {
    AnnuityAmount =
      AnnuityAmount *
      (PensionFrequency === "Yearly"
        ? 1
        : PensionFrequency === "Half-Yearly"
          ? 2
          : PensionFrequency === "Quarterly"
            ? 4
            : 12);
  }

  var tabId = FormStore.quote_formTab === "0";
  var prodCode = tabId ? "I13" : "I14";

  var NPS_Flag = tabId ? FormStore.quote_NPS === "Y" : false;
  var DefermentPeriod = tabId ? "0" : QuoteFormValues["RecAnnuityFreq"];

  var S_DOB = FormStore.joint_DOB;

  var SpouseOpted =
    FormStore.joint_fullName === "" ||
    !marriedArray.includes(FormStore.quote_Pension)
      ? "0"
      : "1";
  var SpouseName = FormStore.joint_fullName;
  var SpouseDOB =
    S_DOB === "" ? "" : FormStore.joint_DOB.split("/").reverse().join("-");
  var NomineeRelation = FormStore.joint_life;
  var SpouseGender = MALE_GENDER_ARRAY.includes(NomineeRelation)
    ? "Male"
    : FEMALE_GENDER_ARRAY.includes(NomineeRelation)
      ? "Female"
      : "";

  // NPS FIX //
  SpouseDOB = NPS_Flag && SpouseDOB === "" ? "1989-01-01" : SpouseDOB;
  // NPS FIX //

  // console.info("Quote Values :", SpouseOpted, FormStore.quote_Pension) // FormStore.calc_dob.split("/").reverse().join("-")

  var updatedList = quoteModal["schemePlan"];
  var finalArray = [];

  var AnnuityPensionFor = [];
  var PensionFor = QuoteFormValues["Pension"];
  PensionFor =
    PensionFor === "Me"
      ? "wantMe"
      : PensionFor === "Me_&_Joint_life"
        ? "wantMeSpouce"
        : PensionFor === "Me_&_Nominee"
          ? "wantMenominee"
          : PensionFor === "Me_Joint_life_&_nominee"
            ? "wantMeSpouceNominee"
            : "wantNfc";
  if (prodCode === "I13") {
    if (PensionFor == "wantMe") {
      AnnuityPensionFor = ["LIFE ANNUITY WITHOUT RETURN OF PURCHASE PRICE"];
    } else if (PensionFor == "wantMeSpouce") {
      AnnuityPensionFor = [
        "JOINT LIFE, LAST SURVIVOR WITHOUT RETURN OF PURCHASE PRICE",
      ];
    } else if (PensionFor == "wantMenominee") {
      AnnuityPensionFor = [
        "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE",
        "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE FROM THE AGE OF 76",
        "LIFE ANNUITY WITH RETURN OF 50 PERCENT PURCHASE PRICE AT AGE 80",
        "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE AT AGE 80",
        "LIFE ANNUITY WITH RETURN OF PURCHASE PRICE ON CI OR PD OR DEATH",
      ]; //FamilyInc ROP Single Life
    } else if (PensionFor == "wantMeSpouceNominee") {
      AnnuityPensionFor = [
        "JOINT LIFE, LAST SURVIVOR WITH RETURN OF PURCHASE PRICE",
      ]; //
    } else if (PensionFor == "wantNfc") {
      AnnuityPensionFor = [
        "FamilyInc ROP Single Life",
        "FamilyInc ROP Joint Life",
      ]; //'FamilyInc ROP Single Life
    }
  } else if (prodCode === "I14") {
    if (PensionFor == "wantMenominee") {
      AnnuityPensionFor = [
        "DEFERRED SINGLE LIFE WITH RETURN OF PURCHASE PRICE",
        "DEFERRED SINGLE LIFE WITH RETURN OF PURCHASE PRICE ON CI OR PD OR DEATH",
      ];
    } else if (PensionFor == "wantMeSpouceNominee") {
      AnnuityPensionFor = ["DEFERRED JOINT LIFE WITH RETURN OF PURCHASE PRICE"];
    }
  }

  for (var i = 0; i < AnnuityPensionFor.length; i++) {
    var AnnuityOption = AnnuityPensionFor[i];
    var keyReq = Object.keys(PayoutOptions).find(
      (key) => PayoutOptions[key] === AnnuityOption,
    );
    // console.info("keyReq :", keyReq)
    var body = {
      FirstName: "",
      LastName: "",
      DateOfBirth: FormStore.calc_dob.split("/").reverse().join("-"), // 2000-02-02
      Gender: Gender,
      MaritalStatus: FormStore.calc_marital,
      PolicyholderFName: "",
      PolicyholderLName: "",
      PolicyholderDOB: "",
      PolicyholderGender: "",
      isNRI: "false",
      isPolicyholder: "false",
      Staff: "0",
      ServiceTaxNotApplicable: "0",
      ProductDetails: {
        Product: {
          ProductType: "Traditional",
          ProductName: "GUARANTEEDPENSIONPLAN",
          ProductCode: prodCode,
          ModeOfPayment: "Yearly",
          ModalPremium: ModalPremium,
          AnnualPremium: ModalPremium,
          Term: "0",
          DeathBenefit: "0",
          PremiumPaymentTerm: "1",
          AnnuityOption: AnnuityOption,
          PensionFrequency: PensionFrequency,
          SpouseOpted: SpouseOpted,
          SpouseName: SpouseName,
          SpouseDOB: SpouseDOB,
          Tobacco: "0",
          SalesChannel: "7",
          AnnuityPayoutFrequency: PensionFrequency,
          PremiumPaymentOption: "Single Pay",
          AnnuityAmount: AnnuityAmount,
          IsAnnuityCalculation: AnnuityAmount === "0" ? "true" : "false",
          QROPS: "false",
          LoyaltyBenefit: "false",
          NPSFlag: NPS_Flag ? "1" : "0",
          SpouseGender: SpouseGender,
          isKeralaCess: "false",
          DefermentPeriod: DefermentPeriod,
          NomineeRelation: NomineeRelation,
          NomineeName: "",
        },
      },
    };

    window.userInputRequestJSON = body;

    const reqParams = {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    };
    // CALCULATE_RETURN_URL = process.env.REACT_APP_CALCULATE_RETURN_PROD_URL;
    var result = {};
    // if (AppStore.isLocalHost) {
    //   console.log("localhost")
    //   const response = await fetch(CALCULATE_RETURN_URL, reqParams)
    //     .then((res) => res.json())
    //     .then((resultOfApi) => {
    //       console.info("Quote API Returns :", resultOfApi)
    //       result = resultOfApi
    //     })
    //     .catch((error) => {
    //       console.info("Error :", error)
    //       result = error
    //     })
    // } else {
    result = await callMiddlewareAPI(ApiName.QUOTE, body);
    // }

    if (result) {
      if (result["ErrorCode"] === "E00") {
        FormStore.setEBIError(false);
        // TotalFirstPrem AnnuityAmount
        var annKey =
          AnnuityAmount === "0" ? "AnnuityAmount" : "TotalFirstPremium";
        var ServiceTax =
          AnnuityAmount === "0" ? 0 : result["PremiumSummary"]["ServiceTax"];
        var AnnuityAmount_API = result["PremiumSummary"][annKey];
        var MulAnnuityOrInvest =
          AnnuityAmount === "0" ? AnnuityAmount_API : AnnuityAmount;
        var AnnuityPayOutFreq_API =
          result["PremiumSummary"]["AnnuityPayoutFrequency"];
        var ModalPremium_API = result["PremiumSummary"]["ModalPremium"];
        var pensionRate = 0;
        var yearlyAnnuityAmt = 0;

        var age = result["PremiumSummary"]["Age"];
        var defermentBy = result["PremiumSummary"]["DefermentPeriod"];
        var totalFirstPremiumShow =
          result["PremiumSummary"]["TotalFirstPremiumShow"];
        if (AnnuityAmount === "0") {
          switch (AnnuityPayOutFreq_API) {
            case "Yearly":
              yearlyAnnuityAmt = Number(MulAnnuityOrInvest) * 1;
              break;
            case "Half-Yearly":
              yearlyAnnuityAmt = Number(MulAnnuityOrInvest) * 2;
              break;
            case "Quarterly":
              yearlyAnnuityAmt = Number(MulAnnuityOrInvest) * 4;
              break;
            case "Monthly":
              yearlyAnnuityAmt = Number(MulAnnuityOrInvest) * 12;
              break;
          }
        } else {
          yearlyAnnuityAmt = AnnuityAmount;
        }

        pensionRate = Number(yearlyAnnuityAmt / ModalPremium_API) * 100;
        console.info(
          "Qupte API Pension Values :",
          AnnuityAmount,
          yearlyAnnuityAmt,
          ModalPremium_API,
        );

        if (AnnuityAmount_API !== undefined) {
          var reqItem = updatedList.find((x) => x.key === Number(keyReq));
          let divFactor = 1.01;

          reqItem["yearlyAnnuityAmt"] = yearlyAnnuityAmt;
          reqItem["value"] = AnnuityAmount_API - ServiceTax;
          reqItem["payoutOption"] = AnnuityOption;
          reqItem["errorMessage"] = "";
          reqItem["disabled"] = false;
          reqItem["pension"] = pensionRate.toFixed(2) + "%";

          // Calculate Extra Savings
          reqItem["pensionWithVal"] = yearlyAnnuityAmt;
          reqItem["pensionWithoutVal"] = yearlyAnnuityAmt / divFactor;
          reqItem["extraSavings"] =
            (reqItem["pensionWithVal"] - reqItem["pensionWithoutVal"]) *
            (85 - age - defermentBy);

          // Calculate Total Pension
          var totalPension = 0;
          var isSingle = reqItem["isSingle"]; // If Single Plan or Joint Plan // true false
          var PrimaryAge = FormStore.calc_age; // Primary Annuitant Age // Customer Age
          var JointAge = FormStore.joint_Age; // Joint Life Age
          var investFlag = AnnuityAmount === "0";
          var AnnuityPayout = investFlag ? yearlyAnnuityAmt : AnnuityAmount;
          console.log(
            "Pension Value Check",
            reqItem["pensionWithVal"],
            reqItem["pensionWithoutVal"],
            age,
            defermentBy,
          );

          if (isSingle) {
            // Single Plan
            totalPension =
              (85 - PrimaryAge - DefermentPeriod) * Number(AnnuityPayout);
          } else if (!isSingle && PrimaryAge > JointAge) {
            // Joint with Primary Age Greater
            totalPension =
              (85 - PrimaryAge - DefermentPeriod) * Number(AnnuityPayout) +
              (PrimaryAge - JointAge) * Number(AnnuityPayout);
          } else if (PrimaryAge < JointAge) {
            // Joint with Primary Age Smaller
            totalPension =
              (85 - PrimaryAge - DefermentPeriod) * Number(AnnuityPayout) +
              (JointAge - PrimaryAge) * Number(AnnuityPayout);
          } else if (PrimaryAge === JointAge) {
            // Same as Single
            totalPension =
              (85 - PrimaryAge - DefermentPeriod) * Number(AnnuityPayout);
          }

          console.info("Modal totalPension :", totalPension);
          reqItem["totalPension"] = totalPension;
          reqItem["totalFirstPremiumShow"] = totalFirstPremiumShow;
          finalArray.push(reqItem);
        }
      } else {
        FormStore.setEBIError(true);
        var reqItem = updatedList.find((x) => x.key === Number(keyReq));
        reqItem["errorMessage"] = result["ErrorMessage"];
        reqItem["disabled"] = true;
        finalArray.push(reqItem);
        console.warn("sakdaskhdbka");
      }
    } else {
      var reqItem = updatedList.find((x) => x.key === Number(keyReq));
      reqItem["errorMessage"] = "Service Unavailable";
      reqItem["disabled"] = true;
      finalArray.push(reqItem);
      FormStore.setEBIError(true);
    }
  }
  return finalArray;
};

const undefinedFlag = (value, altValue) => {
  return value === undefined ? altValue : value;
};

const UserInput = (key, subKey, value) => {
  if (subKey !== "") {
    window.UserInput[key][subKey] = value;
  } else {
    window.UserInput[key] = value;
  }
};

const UserInputReqJSON = (lvl1, lvl2, lvl3, value) => {
  try {
    window.userInputRequestJSON[lvl1][lvl2][lvl3] = value;
  } catch {}
};

const QUOTEPDFAPI = async () => {
  var responsePDF = callMiddlewareAPI(
    ApiName.DOWNLOAD,
    window.userInputRequestJSON,
  ).then((res) => {
    if (res) {
      // console.log("Success" + response);
      //  {"EBIPdfDigital":"https://api.icicilife.com/quote/pdf/KFD_New21082019182120258_T51.pdf"}
      try {
        var title = "Title";
        var text = "ICICI LIFE GUARANTEED PENSION PLAN";
        var url = res.EBIPdfDigital;
        // await navigator.share({title, text, url});
        //SharePDF(title, text, url);
        window.open(
          url,
          "name",
          "toolbar=1,scrollbars=1,location=1,statusbar=0,menubar=1,resizable=1,width=800,height=600",
        );
        // $("body").append('<a id="dnld_pdf" href="' + url +'" download="ICICI PRU SIGNATURE ONLINE"><a>');
        // $("#dnld_pdf").click();
        // $("#dnld_pdf").remove();
      } catch (error) {
        // console.log(error);
      }
    } else {
      // console.log("Failed" + response);
    }
  });
};

export { QuoteAPI, UserInput, undefinedFlag, UserInputReqJSON, QUOTEPDFAPI };
